import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { useState, CSSProperties } from "react";
import { IconButton } from "@mui/material";
import { useRowSelector, useStoreDispatch, useStoreSelector } from "../../../../store/Hooks";
import { navSliceActions } from "../../../../store/slices/NavSlice";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import Interval from "../../../../models/communications/Interval";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import InteractionParentInterval from "../../../../models/interactions/InteractionParentInterval";
import "./styles/MatrixControls.css";
import Tooltip from "@mui/material/Tooltip";
import IntervalSet from "../../../../models/communications/IntervalSet";
import MoreTimeIcon from "@mui/icons-material/MoreTime";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import Button from "@mui/material/Button";
import InteractionDeleteButton from "../../../interactions/ui/InteractionDeleteButton";
import IntervalToCommSetButtonAndMenu from "./IntervalToCommSetButtonAndMenu";
import CommunicationSet from "../../../../models/communications/CommunicationSet";

export interface MatrixIntervalControlsProps {
  associatedInterval: Interval;
  parentID?: number | null;
  setID?: number | null;
  interactionParentInterval?: InteractionParentInterval;
  editMode: boolean;
  intervalSetName: string | null;
  intervalSet?: IntervalSet | null;
  commSetsForIntervalSet: Array<CommunicationSet>
}

const MatrixIntervalControls = (props: MatrixIntervalControlsProps) => {
  const dispatch = useStoreDispatch();
  const interval = useRowSelector(Interval, props.associatedInterval.id);

  function handleOpenEdit() {
    if(props.editMode){
      dispatch(
        navSliceActions.openRightDrawer({
          content: props.associatedInterval,
          type: "intervals",
          extraData: {
            interactionParentInterval: props.interactionParentInterval,
            intervalSet: props.intervalSet,
            parent: props.parentID,
            intervalSetEditMode: props.editMode,
          },
        }),
      );
    }
  }

  const handleDeleteInterval = () => {
    if(interval){
      interval.delete()
    }
  }

  let interactionParentIntervalTestID =
    "editInteractionParentIntervalCommunicationsButton";
  if (props.interactionParentInterval) {
    interactionParentIntervalTestID =
      "editInteractionParentIntervalCommunicationsButton" +
      props.interactionParentInterval.id;
  }

  let editButtonToolTipText = "Edit Interval";
  if (!props.editMode) {
    editButtonToolTipText = "You do not have permission to edit this Interval";
  }

  return (
    <span style={{ textAlign: "center", padding: "0px", marginLeft: "5px" ,}}>
      {/* <div className="sideways-text">{props.associatedInterval.name}</div> */}
      <div
        data-testid={"editIntervalButton" + props.associatedInterval.id}
        style={{
          color: "gray",
          marginTop: "-30px",
          padding: "8px",
          whiteSpace: "nowrap",
          backgroundColor:"#f0faf0",
        }}
      >
        <div
          style={{
            display: "inline-block",
            maxWidth: "250px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            textAlign: "center",
            whiteSpace: "nowrap",
            padding: "0px",
            fontSize: "11pt",
            textDecoration: "underline",
            cursor: "pointer",
            wordWrap: "break-word",
            marginLeft: "5px",
            marginBottom: "-10px",
            fontWeight: "bold",
            backgroundColor:"#f0faf0"
          }}
          onClick={handleOpenEdit}
        >
          {props.associatedInterval.name}
        </div>
        { (
            <IntervalToCommSetButtonAndMenu {...props} />
          )}
        {(
          <InteractionDeleteButton disabled = {!props.editMode} interval={props.associatedInterval} handler={handleDeleteInterval} />
        )}
        <div
          style={{ marginTop: "-5px", fontSize: "8pt", whiteSpace: "nowrap",backgroundColor:"#f0faf0" }}
        >
          {" "}
          <span style={{ marginTop: "-15px" }}>
            <b>Start:</b> {props.associatedInterval.start_day} &nbsp;{" "}
          </span>
          <span>
            <b>End: </b>
            {props.associatedInterval.end_day}
          </span>
        </div>
      </div>
    </span>
  );
};

export default MatrixIntervalControls;
